import React, { memo } from 'react';
import PropTypes from 'prop-types';

import CreateFromScratchCard from '../CreateFromScratchCard';
import PredefinedTemplateCard from '../PredefinedTemplateCard';

/** Grid: two scratch cards plus filtered API templates. */
const TemplatesGrid = memo(
    ({
        searchQuery,
        templates,
        onScratchSelect,
        onUsePredefined,
        onOpenHtmlEditor,
        onOpenVisualEditor,
        onTemplateLibraryChanged,
    }) => {
        const q = (searchQuery || '').trim().toLowerCase();
        const filtered = q
            ? templates.filter((item) => (item?.name || '').toLowerCase().includes(q))
            : templates;

        return (
            <div className="marketing-templates-grid">
                <CreateFromScratchCard variant="html" onSelect={onScratchSelect} />
                <CreateFromScratchCard variant="visual" onSelect={onScratchSelect} />
                {filtered.map((row, index) => (
                    <PredefinedTemplateCard
                        key={row.id != null ? String(row.id) : `tpl-${index}`}
                        template={row}
                        onUseTemplate={onUsePredefined}
                        onOpenHtmlEditor={onOpenHtmlEditor}
                        onOpenVisualEditor={onOpenVisualEditor}
                        onTemplateLibraryChanged={onTemplateLibraryChanged}
                    />
                ))}
            </div>
        );
    },
);

TemplatesGrid.displayName = 'TemplatesGrid';

TemplatesGrid.propTypes = {
    onOpenHtmlEditor: PropTypes.func,
    onOpenVisualEditor: PropTypes.func,
    onScratchSelect: PropTypes.func,
    onTemplateLibraryChanged: PropTypes.func,
    onUsePredefined: PropTypes.func,
    searchQuery: PropTypes.string,
    templates: PropTypes.arrayOf(PropTypes.object),
};

export default TemplatesGrid;
